import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import App from './App.vue';
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.min';
import VueQrcodeReader from 'vue-qrcode-reader';
import formatDate from './filters/formatDate';
import tl from './filters/translateLabel';
import MessageAlerts from './components/app/Messages';
import Notify from './utils/notify';
import router from './router';
import {store} from './store/store';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import './AppIcons';
import i18n from './translations/i18n-setup';

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(VueQrcodeReader);
Vue.use(Notify, {
    visibility: 10000,
    closeButtonClass: 'close',
    position: 'bottom-right',
    enter: 'fadeIn',
    leave: 'fadeOut',
});

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('MessageAlerts', MessageAlerts);

Vue.filter('formatDate', formatDate);
Vue.filter('tl', tl);

new Vue({
    el: '#app',
    i18n,
    store,
    router,
    render: h => h(App),
    created() {
        document.documentElement.setAttribute('lang', store.getters['user/auth/locale']);
    },
});



// WEBPACK FOOTER //
// ./src/main.js